export enum RoleName {
    NONE = 'NONE',
    ADMIN = 'ADMIN',
    CUSTOMER = 'USER',
    SALE = 'SALE',
    SALE_MANAGER = 'SALE_MANAGER',
    TECHNICIAN = 'TECHNICIAN',
}
